import type { UserLocalStorage } from '../../types/localStorage';

import { useQuery } from '@tanstack/react-query';
import useLocalStorageState from 'use-local-storage-state';

import { getUser } from '../../lib/flotiq-client';
import { parseResponseErrors } from '../../lib/flotiq-client/response-errors';

import useToken from '../../hooks/useToken';

export const useLoggedUser = () => {
  const jwt = useToken();
  const [user] = useLocalStorageState<UserLocalStorage>('cms.user');
  const userId = user?.data?.id;

  const { isLoading, data: response } = useQuery({
    queryKey: ['logged-users', { id: userId }],
    queryFn: async ({ signal }) => {
      const result = await getUser(jwt, undefined, { id: userId }, { signal });
      if (!result.ok) {
        throw parseResponseErrors(result.body, result.status);
      }
      return Promise.resolve(result);
    },
    enabled: !!jwt && !!userId,
    staleTime: Infinity,
    gcTime: 0,
    retry: 0,
  });

  return { isLoading, user: response?.body };
};
